import { supabase } from '@/lib/supabase'

const BUCKET = 'fotos-obras'

/**
 * Extract the storage path from a full Supabase storage URL.
 * Handles both /public/ and /sign/ URL formats, and decodes %20 etc.
 */
function extractPathFromUrl(url: string): string | null {
  try {
    const urlObj = new URL(url)
    for (const segment of ['/public/fotos-obras/', '/sign/fotos-obras/', '/object/fotos-obras/']) {
      const idx = urlObj.pathname.indexOf(segment)
      if (idx !== -1) {
        return decodeURIComponent(urlObj.pathname.slice(idx + segment.length))
      }
    }
    return null
  } catch {
    return null
  }
}

/**
 * Resolve a logo_url (which may be a relative path or a full URL) into a
 * usable signed URL. Returns null if resolution fails.
 *
 * Logs bucket, path, and result for debugging.
 */
export async function resolveLogoUrl(logoUrl: string | null | undefined): Promise<string | null> {
  if (!logoUrl || !logoUrl.trim()) {
    console.log('[Logo] No logo_url provided')
    return null
  }

  const url = logoUrl.trim()

  // If it's an external URL not from our storage, use directly
  if (url.startsWith('http') && !url.includes('fotos-obras')) {
    console.log('[Logo] External URL, using directly:', url)
    return url
  }

  // Determine the storage path
  const path = url.startsWith('http') ? extractPathFromUrl(url) : url

  console.log('[Logo] bucket:', BUCKET)
  console.log('[Logo] saved value:', url)
  console.log('[Logo] resolved path:', path)

  if (!path) {
    console.warn('[Logo] Could not extract path from URL')
    return null
  }

  try {
    const { data, error } = await supabase.storage
      .from(BUCKET)
      .createSignedUrl(path, 3600)

    if (data?.signedUrl && !error) {
      console.log('[Logo] Signed URL generated successfully')
      return data.signedUrl
    }

    console.warn('[Logo] createSignedUrl failed:', error?.message)
    return null
  } catch (err) {
    console.error('[Logo] Error resolving logo:', err)
    return null
  }
}
